/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgItalicKazakh = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m862 953 454 647h187l-90 448h-192l51-256h-68l-513-758q-10-14-18-30t-17-32h-5l-176 820H272L630 128h206L667 910h5q13-14 27-28t28-29l780-725h269L862 953z"
    }));
export default SvgItalicKazakh;
